var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUzbekistan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 30,
    viewBox: "0 0 61 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6339_387757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.113281 0H60.1133V30H0.113281V0Z",
    fill: "#1EB53A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.113281 0H60.1133V15H0.113281V0Z",
    fill: "#0099B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.113281 9.60016H60.1133V20.4002H0.113281V9.60016Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.113281 10.2H60.1133V19.8H0.113281V10.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51321 8.40001C10.5014 8.40001 12.1132 6.78824 12.1132 4.80001C12.1132 2.81179 10.5014 1.20001 8.51321 1.20001C6.52498 1.20001 4.91321 2.81179 4.91321 4.80001C4.91321 6.78824 6.52498 8.40001 8.51321 8.40001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71328 8.40001C11.7015 8.40001 13.3133 6.78824 13.3133 4.80001C13.3133 2.81179 11.7015 1.20001 9.71328 1.20001C7.72506 1.20001 6.11328 2.81179 6.11328 4.80001C6.11328 6.78824 7.72506 8.40001 9.71328 8.40001Z",
    fill: "#0099B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4327 6.96011L16.2107 7.64411L16.5527 7.75811",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4334 6.96011L16.6554 7.64411L16.3134 7.75811",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1176 7.45782H16.3976V7.81782",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1167 7.45782L16.5347 7.88382L16.3247 7.58982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7492 7.45782L16.3312 7.88382L16.5412 7.58982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7492 7.45782H16.4692V7.81782",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8597 8.26194L16.6377 7.57794L16.2957 7.69194",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8588 8.26218L16.2768 7.83618L16.4868 7.54218",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0072 8.26218L16.5892 7.83618L16.3792 7.54218",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0072 8.26194L16.2292 7.57794L16.5712 7.69194",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4327 4.0799L16.2107 4.76389L16.5527 4.87789",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4334 4.0799L16.6554 4.76389L16.3134 4.87789",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1176 4.57794H16.3976V4.93794",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1167 4.57794L16.5347 5.00394L16.3247 4.70994",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7492 4.57794L16.3312 5.00394L16.5412 4.70994",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7492 4.57794H16.4692V4.93794",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8597 5.38169L16.6377 4.69769L16.2957 4.81169",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8588 5.38226L16.2768 4.95626L16.4868 4.66226",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0072 5.38226L16.5892 4.95626L16.3792 4.66226",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4327 1.20001L16.2107 1.88401L16.5527 1.99801",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4334 1.20001L16.6554 1.88401L16.3134 1.99801",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1176 1.69769H16.3976V2.05769",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1167 1.69769L16.5347 2.12369L16.3247 1.82969",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7492 1.69769L16.3312 2.12369L16.5412 1.82969",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7492 1.69769H16.4692V2.05769",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8597 2.50181L16.6377 1.81781L16.2957 1.93181",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8588 2.50204L16.2768 2.07604L16.4868 1.78204",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0072 2.50204L16.5892 2.07604L16.3792 1.78204",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3137 6.96011L19.0917 7.64411L19.4337 7.75811",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3131 6.96011L19.5351 7.64411L19.1931 7.75811",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9968 7.45782H19.2768V7.81782",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9977 7.45782L19.4157 7.88382L19.2057 7.58982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 7.45782L19.2109 7.88382L19.4209 7.58982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 7.45782H19.3489V7.81782",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7394 8.26194L19.5174 7.57794L19.1754 7.69194",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7398 8.26218L19.1578 7.83618L19.3678 7.54218",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8869 8.26218L19.4689 7.83618L19.2589 7.54218",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3137 4.0799L19.0917 4.76389L19.4337 4.87789",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3131 4.0799L19.5351 4.76389L19.1931 4.87789",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9968 4.57794H19.2768V4.93794",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 4.57794L19.2109 5.00394L19.4209 4.70994",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 4.57794H19.3489V4.93794",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7394 5.38169L19.5174 4.69769L19.1754 4.81169",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8868 5.38226L19.4688 4.95626L19.2588 4.66226",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3137 1.20001L19.0917 1.88401L19.4337 1.99801",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3131 1.20001L19.5351 1.88401L19.1931 1.99801",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9968 1.69769H19.2768V2.05769",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 1.69769L19.2109 2.12369L19.4209 1.82969",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 1.69769H19.3489V2.05769",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7394 2.50181L19.5174 1.81781L19.1754 1.93181",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8868 2.50204L19.4688 2.07604L19.2588 1.78204",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1934 6.96011L21.9714 7.64411L22.3134 7.75811",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1927 6.96011L22.4147 7.64411L22.0727 7.75811",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8778 7.45782H22.1578V7.81782",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.877 7.45782L22.295 7.88382L22.085 7.58982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5099 7.45782L22.0919 7.88382L22.3019 7.58982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5099 7.45782H22.2299V7.81782",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6191 8.26194L22.3971 7.57794L22.0551 7.69194",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6195 8.26218L22.0375 7.83618L22.2475 7.54218",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7679 8.26218L22.3499 7.83618L22.1399 7.54218",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1934 4.0799L21.9714 4.76389L22.3134 4.87789",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1927 4.0799L22.4147 4.76389L22.0727 4.87789",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8778 4.57794H22.1578V4.93794",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5099 4.57794L22.0919 5.00394L22.3019 4.70994",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5099 4.57794H22.2299V4.93794",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6191 5.38169L22.3971 4.69769L22.0551 4.81169",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7679 5.38226L22.3499 4.95626L22.1399 4.66226",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1934 1.20001L21.9714 1.88401L22.3134 1.99801",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1927 1.20001L22.4147 1.88401L22.0727 1.99801",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8778 1.69769H22.1578V2.05769",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5099 1.69769L22.0919 2.12369L22.3019 1.82969",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5099 1.69769H22.2299V2.05769",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6191 2.50181L22.3971 1.81781L22.0551 1.93181",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7679 2.50204L22.3499 2.07604L22.1399 1.78204",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6738 6.96011L10.4518 7.64411L10.7938 7.75811",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6731 6.96011L10.8951 7.64411L10.5531 7.75811",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3569 7.45782H10.6369V7.81782",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3573 7.45782L10.7753 7.88382L10.5653 7.58982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.989 7.45782L10.571 7.88382L10.781 7.58982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.989 7.45782H10.709V7.81782",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0995 8.26194L10.8775 7.57794L10.5355 7.69194",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0999 8.26218L10.5179 7.83618L10.7279 7.54218",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.247 8.26218L10.829 7.83618L10.619 7.54218",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.247 8.26194L10.469 7.57794L10.811 7.69194",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.553 6.96011L13.331 7.64411L13.673 7.75811",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5528 6.96011L13.7748 7.64411L13.4328 7.75811",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2379 7.45782H13.5179V7.81782",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.237 7.45782L13.655 7.88382L13.445 7.58982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87 7.45782L13.452 7.88382L13.662 7.58982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87 7.45782H13.59V7.81782",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9792 8.26194L13.7572 7.57794L13.4152 7.69194",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9796 8.26218L13.3976 7.83618L13.6076 7.54218",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1275 8.26218L13.7095 7.83618L13.4995 7.54218",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1275 8.26194L13.3495 7.57794L13.6915 7.69194",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.553 4.0799L13.331 4.76389L13.673 4.87789",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5528 4.0799L13.7748 4.76389L13.4328 4.87789",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2379 4.57794H13.5179V4.93794",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.237 4.57794L13.655 5.00394L13.445 4.70994",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87 4.57794L13.452 5.00394L13.662 4.70994",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87 4.57794H13.59V4.93794",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9792 5.38169L13.7572 4.69769L13.4152 4.81169",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9796 5.38226L13.3976 4.95626L13.6076 4.66226",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1275 5.38226L13.7095 4.95626L13.4995 4.66226",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1275 5.38169L13.3495 4.69769L13.6915 4.81169",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6339_387757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 30,
    fill: "white",
    transform: "translate(0.113281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzbekistan);
export default __webpack_public_path__ + "static/media/uzbekistan.dff6652539692f9acc309d77b2dfc3ce.svg";
export { ForwardRef as ReactComponent };